import React, { FC } from 'react';
import { RadioButton } from 'react-native-paper';
import Constants from 'expo-constants'; // TODO: REMOVE AFTER BETA
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import View from '../View';
import styles from './styles';
import { iconGrey, orange } from '../../../constants/palette';
import { ARTIST, FAN } from './constants';

export type UserRoleSelectionProps = {
  setFieldValue: Function;
  value: string;
};

export const UserRoleSelection: FC<UserRoleSelectionProps> = (props) => {
  const { setFieldValue, value } = props;

  // ===============================
  // TODO: REMOVE AFTER BETA IS DONE
  const isCreateUserButtonDisabled =
    Constants.manifest.extra.environment === 'beta';
  const fanTextSyle = isCreateUserButtonDisabled
    ? styles.disabledText
    : styles.text;
  // ===============================
  return (
    <View>
      <RadioButton.Group
        value={value}
        onValueChange={(value) => setFieldValue('userType', value)}
      >
        <View style={styles.radioGroup}>
          <View style={styles.radioButton}>
            <RadioButton
              color={orange}
              status={value === 'arist' ? 'checked' : 'unchecked'}
              uncheckedColor={iconGrey}
              value="artist"
              disabled={isCreateUserButtonDisabled}
            />
            {/*  TODO: Remove after fan beta #2 is completed */}
            <View style={styles.textSelectionWrapper}>
              <GalanoGrotesqueText style={styles.text}>
                {ARTIST}
              </GalanoGrotesqueText>
              {!!isCreateUserButtonDisabled && (
                <GalanoGrotesqueText style={styles.subText}>
                  disabled for beta
                </GalanoGrotesqueText>
              )}
            </View>
          </View>

          <View style={styles.radioButton}>
            <RadioButton
              color={orange}
              status={value === 'fan' ? 'checked' : 'unchecked'}
              uncheckedColor={iconGrey}
              value="fan"
            />
            <View style={styles.textSelectionWrapper}>
              <GalanoGrotesqueText style={fanTextSyle}>
                {FAN}
              </GalanoGrotesqueText>
              <GalanoGrotesqueText style={styles.subTextSpotify}>
                *Spotify premium
              </GalanoGrotesqueText>
              <GalanoGrotesqueText style={styles.subTextSpotify}>
                required
              </GalanoGrotesqueText>
            </View>
          </View>
        </View>
      </RadioButton.Group>
    </View>
  );
};

export default UserRoleSelection;
